module.exports = __webpack_public_path__ + "static/media/Ellipsis.0fcd53a0.svg";